module.exports = __webpack_public_path__ + "img/2025-05-09c_1.bc79adb0.jpg";